import InterpretationInterface from './interpretation-interface';

class YahooInterpretation implements InterpretationInterface {
    interpretPlayerExternalId(content: string): string {
        const [id] = content.split(' - ');

        return id.trim();
    }
}

export default YahooInterpretation;
